import * as formatParse from 'common/format-parse';
import { Format } from 'nomst/Stores/Utility/format';
import { observable, action, makeObservable } from 'mobx';

export type percentageOnChangeCallback = (percentage: number) => void;

export class Percentage {
    @observable percentage: Nullable<number>;
    @observable percentageInput: Nullable<string>;
    @observable percentageText: Nullable<string>;
    @observable errorMessageText: Nullable<string>;
    @observable onChangeCallback: percentageOnChangeCallback;
    _format: Format;

    constructor(format: Format) {
        makeObservable(this);
        this._format = format;
    }

    formatPercentageText(): string {
        if (this.percentage == null) {
            return '';
        }
        return (this.percentage >= 0) ? this._format.formatPercentage(this.percentage) : '';
    }

    get increasePercentageText(): string {
        if (this.percentageText != null) {
            return this.percentageText;
        }

        return this.formatPercentageText();
    }

    @action
    setOnChangeCallback(callBack: percentageOnChangeCallback): void {
        this.onChangeCallback = callBack;
    }

    @action
    clearErrorMessage(): void {
        this.errorMessageText = null;
    }

    @action
    changePercentage(percentageText: string): void {
        this.clearErrorMessage();
        this.percentageText = percentageText;
        this.percentageInput = formatParse.stripNonPercentage(percentageText);
        this.percentage = formatParse.parseValueOrDefault(percentageText, 0);
    }

    @action
    onBlur(): void {
        this.clearErrorMessage();
        if (this.percentageInput === null) {
            return;
        }

        this.percentageText = this.formatPercentageText();
        if (this.percentage == null) {
            return;
        }
        this.onChangeCallback?.(this.percentage);
    }
}